import { render, staticRenderFns } from "./created.vue?vue&type=template&id=564df022&scoped=true"
import script from "./created.vue?vue&type=script&lang=js"
export * from "./created.vue?vue&type=script&lang=js"
import style0 from "./created.vue?vue&type=style&index=0&id=564df022&prod&lang=scss&scoped=true"
import style1 from "./created.vue?vue&type=style&index=1&id=564df022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564df022",
  null
  
)

export default component.exports